import { __styles, mergeClasses, shorthands, tokens } from '@fluentui/react-components';
export const copilotMessageFooterClassNames = {
  root: 'fai-CopilotMessageFooter',
  content: 'fai-CopilotMessageFooter__content',
  responseCount: 'fai-CopilotMessageFooter__responseCount',
  feedback: 'fai-CopilotMessageFooter__feedback',
  aiDisclaimer: 'fai-CopilotMessageFooter__aiDisclaimer',
  referenceList: 'fai-CopilotMessageFooter__referenceList',
  referenceListToggle: 'fai-CopilotMessageFooter__referenceListToggle',
  divider: 'fai-CopilotMessageFooter__divider',
  sensitivity: 'fai-CopilotMessageFooter__sensitivity',
  sensitivityDisclaimerContainer: 'fai-CopilotMessageFooter__sensitivityDisclaimerContainer'
};
/**
 * Styles for the root slot
 */
const useStyles = __styles({
  root: {
    mc9l5x: "f13qh94s",
    Bt984gj: "f122n59",
    Belr9w4: "f778t4r",
    i8kkvl: "fsnqrgy"
  },
  sidecar: {
    zoa1oz: "f1uzz097",
    Budl1dq: "fjxzuw"
  },
  canvas: {
    zoa1oz: "fro7rzp",
    Budl1dq: "f1c2z91y"
  },
  content: {
    Ijaq50: "fxwmwwq",
    Br312pm: "f1e0gndy",
    nk6f5a: "f4zz6gv",
    Bw0ie65: "f7idnck"
  },
  responseCount: {
    Ijaq50: "f5otnkn",
    Br312pm: "fbv9w6a",
    nk6f5a: "f936obl",
    Bw0ie65: "ffdhz2g",
    mc9l5x: "ftuwxu6",
    Brf1p80: "f9c4gz4",
    sshi5w: "f1pha7fy"
  },
  feedback: {
    Ijaq50: "fa7eky8",
    Br312pm: "f1f8bjyo",
    nk6f5a: "f14jo9ci",
    Bw0ie65: "f13jgg2r",
    mc9l5x: "ftuwxu6",
    Brf1p80: "f9c4gz4"
  },
  aiDisclaimer: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62"
  },
  referenceList: {
    Ijaq50: "f287s05",
    Br312pm: "f15kmoja",
    nk6f5a: "fhx7lth",
    Bw0ie65: "fzr3ok5"
  },
  referenceListToggle: {
    Ijaq50: "fot7p39",
    Br312pm: "fskgwab",
    nk6f5a: "fna62b2",
    Bw0ie65: "f1sgo3dm"
  },
  divider: {
    Ijaq50: "f78rlfx",
    Br312pm: "fm7ow19",
    nk6f5a: "f2yvwxb",
    Bw0ie65: "f1vstwpc",
    sshi5w: "f1dlyyta",
    Bxyxcbc: "f1gb6uef",
    a9b677: "f18ezo4q"
  },
  sensitivity: {
    Bt984gj: "f122n59",
    mc9l5x: "f22iagw"
  },
  sensitivityDisclaimer: {
    Ijaq50: "fespyqd",
    Br312pm: "fe7c7b2",
    nk6f5a: "fpt6gu6",
    Bw0ie65: "f1ndq4m6",
    Bt984gj: "f122n59",
    mc9l5x: "f22iagw",
    Beiy3e4: "f1063pyq",
    i8kkvl: "fsnqrgy",
    Belr9w4: "fylz90v"
  }
}, {
  d: [".f13qh94s{display:grid;}", ".f122n59{align-items:center;}", ".f778t4r{row-gap:var(--spacingVerticalXS);}", ".fsnqrgy{column-gap:var(--spacingHorizontalS);}", ".f1uzz097{grid-template-areas:\"content                       content                        content\" \"sensitivityDisclaimer         sensitivityDisclaimer          feedback\" \"referenceToggle               responseCount                  responseCount\" \"referenceList                 referenceList                  referenceList\";}", ".fjxzuw{grid-template-columns:auto 1fr;}", ".fro7rzp{grid-template-areas:\"content             content            content             content                       content\" \"referenceToggle     responseCount      divider             sensitivityDisclaimer         feedback\" \"referenceList       referenceList      referenceList       referenceList                 referenceList\";}", ".f1c2z91y{grid-template-columns:1fr;}", ".fxwmwwq{grid-row-start:content;}", ".f1e0gndy{grid-column-start:content;}", ".f4zz6gv{grid-row-end:content;}", ".f7idnck{grid-column-end:content;}", ".f5otnkn{grid-row-start:responseCount;}", ".fbv9w6a{grid-column-start:responseCount;}", ".f936obl{grid-row-end:responseCount;}", ".ffdhz2g{grid-column-end:responseCount;}", ".ftuwxu6{display:inline-flex;}", ".f9c4gz4{justify-content:flex-end;}", ".f1pha7fy{min-height:24px;}", ".fa7eky8{grid-row-start:feedback;}", ".f1f8bjyo{grid-column-start:feedback;}", ".f14jo9ci{grid-row-end:feedback;}", ".f13jgg2r{grid-column-end:feedback;}", ".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}", ".f287s05{grid-row-start:referenceList;}", ".f15kmoja{grid-column-start:referenceList;}", ".fhx7lth{grid-row-end:referenceList;}", ".fzr3ok5{grid-column-end:referenceList;}", ".fot7p39{grid-row-start:referenceToggle;}", ".fskgwab{grid-column-start:referenceToggle;}", ".fna62b2{grid-row-end:referenceToggle;}", ".f1sgo3dm{grid-column-end:referenceToggle;}", ".f78rlfx{grid-row-start:divider;}", ".fm7ow19{grid-column-start:divider;}", ".f2yvwxb{grid-row-end:divider;}", ".f1vstwpc{grid-column-end:divider;}", ".f1dlyyta{min-height:var(--lineHeightBase100);}", ".f1gb6uef{max-height:var(--lineHeightBase100);}", ".f18ezo4q{width:var(--spacingHorizontalM);}", ".fespyqd{grid-row-start:sensitivityDisclaimer;}", ".fe7c7b2{grid-column-start:sensitivityDisclaimer;}", ".fpt6gu6{grid-row-end:sensitivityDisclaimer;}", ".f1ndq4m6{grid-column-end:sensitivityDisclaimer;}", ".f1063pyq{flex-direction:row;}", ".fylz90v{row-gap:var(--spacingHorizontalS);}"]
});
/**
 * Apply styling to the CopilotMessageFooter slots based on the state
 */
export const useCopilotMessageFooterStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(copilotMessageFooterClassNames.root, styles.root, styles[state.mode], state.root.className);
  if (state.content) {
    state.content.className = mergeClasses(copilotMessageFooterClassNames.content, styles.content, state.content.className);
  }
  if (state.responseCount) {
    state.responseCount.className = mergeClasses(copilotMessageFooterClassNames.responseCount, styles.responseCount, state.responseCount.className);
  }
  if (state.feedback) {
    state.feedback.className = mergeClasses(copilotMessageFooterClassNames.feedback, styles.feedback, state.feedback.className);
  }
  if (state.aiDisclaimer) {
    state.aiDisclaimer.className = mergeClasses(copilotMessageFooterClassNames.aiDisclaimer, styles.aiDisclaimer, state.aiDisclaimer.className);
  }
  if (state.referenceList) {
    state.referenceList.className = mergeClasses(copilotMessageFooterClassNames.referenceList, styles.referenceList, state.referenceList.className);
  }
  if (state.referenceListToggle) {
    state.referenceListToggle.className = mergeClasses(copilotMessageFooterClassNames.referenceListToggle, styles.referenceListToggle, state.referenceListToggle.className);
  }
  if (state.divider) {
    state.divider.className = mergeClasses(copilotMessageFooterClassNames.divider, styles.divider, state.divider.className);
  }
  if (state.sensitivity) {
    state.sensitivity.className = mergeClasses(copilotMessageFooterClassNames.sensitivity, styles.sensitivity, state.sensitivity.className);
  }
  if (state.sensitivityDisclaimerContainer) {
    state.sensitivityDisclaimerContainer.className = mergeClasses(copilotMessageFooterClassNames.sensitivityDisclaimerContainer, styles.sensitivityDisclaimer, state.sensitivityDisclaimerContainer.className);
  }
  return state;
};
//# sourceMappingURL=useCopilotMessageFooterStyles.js.map